import { isAppWebview } from '../userAgent'

export const useJSBridgeFn = <
  TIn,
  TOut = void,
  TFn = ((input: TIn) => TOut) | (() => TOut),
>(
  webFn: TFn,
  nativeFn: TFn,
) => {
  const isWebView = isAppWebview()

  const fn = isWebView ? nativeFn : webFn

  return fn
}
